import {useAuthQuery} from '#lib/hooks/use-auth-query.js';
import {jsonHeaders} from '#lib/helpers/fetch.js';
import {useState} from 'react';

async function fetchThemes(_, authHeaders) {
    const response = await fetch(`${API_URL}/p/themes`, {
        method: 'GET',
        headers: {...jsonHeaders, ...authHeaders}
    });
    return await response.json();
}

export function useThemes() {
    const {data, ...queryProps} = useAuthQuery({
        queryKey: ['themes'],
        queryFn: fetchThemes,
        staleTime: Infinity,
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        retry: false,
        cacheTime: 0
    });

    const [theme, setTheme] = useState(null);
    const [styles, setStyles] = useState(null);
    const [primaryPalette, setPrimaryPalette] = useState('');
    const [neutralPalette, setNeutralPalette] = useState('');
    const [reset, setReset] = useState(false);

    return {
        themes: data?.results,
        theme,
        setTheme,
        styles,
        setStyles,
        primaryPalette,
        setPrimaryPalette,
        neutralPalette,
        setNeutralPalette,
        reset,
        setReset,
        ...queryProps
    };
}
